"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("@emotion/react");
exports.default = (0, react_1.css) `
    @font-face {
        font-family: 'YS Text Web';
        src: url('https://yastatic.net/islands/_/PyVcRbwHetz0gOVWLonWH7Od8zM.woff2') format('woff2'),
            url('https://yastatic.net/islands/_/bIx8jOfCEfR-mECoDUEZywDBuHA.woff') format('woff');
        font-weight: 400;
        font-style: normal;
        font-display: swap;
    }
    @font-face {
        font-family: 'YS Text Web';
        src: url('https://yastatic.net/islands/_/7_GKBdKFbUPzKlghJRv55xgz0FQ.woff2') format('woff2'),
            url('https://yastatic.net/islands/_/SmqPmIMEXrW4lOY8QrhTUVDbrro.woff') format('woff');
        font-weight: 500;
        font-style: normal;
        font-display: swap;
    }
    .pythia-surveys-root {
        /*
            из-за пересечений по названию с css (--app-padding-top)
            возникали баги парсинга в postcss-css-variables
        */
        --app-paddingtop: 35px;
        --app-paddingbtm: 70px;
        --page-paddingright: 3em;
        --page-paddingleft: 3em;
        --page-paddingbottom: 0;
        --next-btn-height: 32px;
        --next-btn-fontsize: 13px;
        --min-header-fontsize: 8px; /* ограничиваем размер чтобы был текст оставался читаемым */
        --min-header-side-fontsize: 11px;

        --rem: 100px;
    }

    .app_theme_video {
        font-size: 0.1em; /* компенсируем 10x размер текста на html */

        border-spacing: 0;
        font-family: var(--main-font);
        font-display: swap;

        height: 100%;
        max-height: 100%;
        width: 100%;
        box-sizing: border-box;
        background: #182431;
        -webkit-font-smoothing: antialiased;
        padding: 0;
        padding-top: var(--app-paddingtop);
        padding-bottom: var(--app-paddingbtm);

        display: table;
        border-collapse: separate; /* по-умолчанию применяются стили yaplayertag с collapse */
    }

    .app_maxWidth-300_yes.app_theme_video {
        --rem: 80px;
    }

    .app__footer {
        height: 5em;
    }

    .app__thanks {
        text-align: center;
        font-size: 3em;
    }

    .y-button_size_l {
        height: 40px;
        line-height: 40px;
        font-size: 17px;
    }

    /*relative*/
    .y-button.y-button_size_r {
        font-size: 1.8em;
        height: 2.1em;
        line-height: 2.1em;
        padding: 0 1em;
        width: 100%;
        outline: none;
    }

    .y-button_theme_fixed {
        background: var(--view-default-fill-color-action);
        font-size: 2.4em !important;
        position: fixed !important;
        border: none !important;
        bottom: 0;
        left: 0;
        right: 0;
    }

    /* transition c задержкой чтобы не мерцал текст из-за блокировки на время пересчета логики */
    .page__button-next .y-button__text {
        transition: 0.1s 0.5s;
    }
`;
